export type Platform = 'ios' | 'android' | 'desktop';

export function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'desktop';

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  if (/android/i.test(ua)) return 'android';

  // iPhone / iPod / iPad on iOS <= 12
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';

  // iPadOS 13+ reports as MacIntel but exposes touch points
  if (platform === 'MacIntel' && maxTouchPoints > 1) return 'ios';

  return 'desktop';
}
